import React, { createContext, useContext, useCallback } from 'react';
export const CustomNotificationContext = /*#__PURE__*/ createContext({
    notifications: [],
    removeNotification: ()=>null
});
CustomNotificationContext.displayName = 'CustomNotificationContext';
export const CustomNotificationProvider = ({ children , notifications , removeNotification , queueName  })=>{
    const remove = useCallback((id)=>removeNotification(queueName, id), [
        queueName,
        removeNotification
    ]);
    return /*#__PURE__*/ React.createElement(CustomNotificationContext.Provider, {
        value: {
            notifications,
            removeNotification: remove
        }
    }, children);
};
export function useCustomNotifications(notificationTypes) {
    const { notifications =[] , removeNotification  } = useContext(CustomNotificationContext);
    const filteredNotifications = notificationTypes ? notifications.filter((item)=>notificationTypes.includes(item.type)) : notifications;
    return {
        notifications: filteredNotifications,
        removeNotification
    };
}
